var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb__container"},[_c('div',{staticClass:"pb__bar"},[_c('div',{staticClass:"pb__progress",style:({ width: _vm.value + '%'})}),_c('div',{staticClass:"pb__background"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }